// src/pages/public/CompraPrueba.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Document, Page, Text, View, StyleSheet, pdf } from '@react-pdf/renderer';

const CompraPrueba = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // ✅ PRUEBA 1: PDF con estilos mínimos
  const probarPDFMinimo = async () => {
    setLoading(true);
    try {
      console.log('🔬 Probando PDF mínimo...');
      
      const blob = await pdf(
        <Document>
          <Page size="A4" style={{ padding: 50 }}>
            <Text style={{ fontSize: 20, fontWeight: 'bold' }}>PDF Mínimo</Text>
            <Text style={{ fontSize: 12, marginTop: 20 }}>Este es un PDF con estilos mínimos.</Text>
            <Text style={{ fontSize: 12, marginTop: 10 }}>Fecha: {new Date().toLocaleString()}</Text>
          </Page>
        </Document>
      ).toBlob();
      
      console.log('✅ PDF mínimo generado!', blob);
      
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'prueba-minimo.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      Swal.fire('Éxito', 'El PDF mínimo se descargó correctamente', 'success');
    } catch (error) {
      console.error('❌ Error en PDF mínimo:', error);
      Swal.fire('Error', `Error: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  // ✅ PRUEBA 2: PDF con estilos completos (simulando ComprobantePDF)
  const probarPDFConEstilos = async () => {
    setLoading(true);
    try {
      console.log('🔬 Probando PDF con estilos completos...');
      
      const styles = StyleSheet.create({
        page: { padding: 40, backgroundColor: '#ffffff' },
        header: { backgroundColor: '#1a202c', padding: 20, marginBottom: 20, borderRadius: 4, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
        headerTitle: { fontSize: 20, fontWeight: 'bold', color: '#ffffff' },
        headerSubtitle: { fontSize: 10, color: '#a0aec0' },
        section: { marginBottom: 14, padding: 14, backgroundColor: '#f7fafc', borderRadius: 4 },
        sectionTitle: { fontSize: 13, fontWeight: 'bold', color: '#2d3748', marginBottom: 6, paddingBottom: 4, borderBottomWidth: 1, borderBottomColor: '#e2e8f0' },
        row: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 2 },
        label: { fontSize: 10, color: '#718096' },
        value: { fontSize: 10, color: '#2d3748', fontWeight: 'normal' }, // ✅ CAMBIADO: 'medium' → 'normal'
        codeContainer: { backgroundColor: '#ebf8ff', padding: 10, borderRadius: 4, alignItems: 'center', marginBottom: 10 },
        codeText: { fontSize: 16, fontWeight: 'bold', color: '#2b6cb0' }, // ✅ ELIMINADO: fontFamily: 'Courier'
        totalContainer: { backgroundColor: '#2d3748', padding: 14, borderRadius: 4, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 },
        totalLabel: { fontSize: 14, color: '#ffffff', fontWeight: 'bold' },
        totalValue: { fontSize: 22, color: '#68d391', fontWeight: 'bold' },
        passengerItem: { flexDirection: 'row', alignItems: 'center', paddingVertical: 3, paddingHorizontal: 8, backgroundColor: '#ffffff', borderRadius: 4, marginVertical: 2, borderWidth: 1, borderColor: '#e2e8f0' },
        passengerNumber: { fontSize: 9, color: '#718096', marginRight: 6 },
        passengerName: { fontSize: 10, color: '#2d3748', flex: 1 },
        passengerCedula: { fontSize: 9, color: '#718096' },
        footer: { marginTop: 16, paddingTop: 10, borderTopWidth: 1, borderTopColor: '#e2e8f0', alignItems: 'center' },
        footerText: { fontSize: 8, color: '#a0aec0' },
        estadoBadge: { paddingHorizontal: 10, paddingVertical: 3, borderRadius: 10, backgroundColor: '#f6e05e' },
        estadoText: { fontSize: 9, fontWeight: 'bold', color: '#744210' },
      });
      
      const blob = await pdf(
        <Document>
          <Page size="A4" style={styles.page}>
            <View style={styles.header}>
              <View>
                <Text style={styles.headerTitle}>Comprobante de Prueba</Text>
                <Text style={styles.headerSubtitle}>N° de prueba: TEST-123</Text>
              </View>
              <View style={styles.estadoBadge}>
                <Text style={styles.estadoText}>Pendiente</Text>
              </View>
            </View>

            <View style={styles.codeContainer}>
              <Text style={styles.codeText}>CÓDIGO: PRUEBA-123</Text>
            </View>

            <View style={styles.section}>
              <Text style={styles.sectionTitle}>Datos de prueba</Text>
              <View style={styles.row}>
                <Text style={styles.label}>Etiqueta:</Text>
                <Text style={styles.value}>Valor de prueba</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Origen:</Text>
                <Text style={styles.value}>Ciudad de Prueba</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Destino:</Text>
                <Text style={styles.value}>Destino de Prueba</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Fecha:</Text>
                <Text style={styles.value}>{new Date().toLocaleDateString()}</Text>
              </View>
            </View>

            <View style={styles.section}>
              <Text style={styles.sectionTitle}>Pasajeros (2)</Text>
              <View style={styles.passengerItem}>
                <Text style={styles.passengerNumber}>1.</Text>
                <Text style={styles.passengerName}>Juan Pérez</Text>
                <Text style={styles.passengerCedula}>Cédula: 12.345.678-9</Text>
              </View>
              <View style={styles.passengerItem}>
                <Text style={styles.passengerNumber}>2.</Text>
                <Text style={styles.passengerName}>María Gómez</Text>
                <Text style={styles.passengerCedula}>Cédula: 98.765.432-1</Text>
              </View>
            </View>

            <View style={styles.totalContainer}>
              <Text style={styles.totalLabel}>TOTAL</Text>
              <Text style={styles.totalValue}>$100.000</Text>
            </View>

            <View style={styles.footer}>
              <Text style={styles.footerText}>Generado el {new Date().toLocaleString()}</Text>
            </View>
          </Page>
        </Document>
      ).toBlob();
      
      console.log('✅ PDF con estilos generado!', blob);
      
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'prueba-estilos.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      Swal.fire('Éxito', 'El PDF con estilos se descargó correctamente', 'success');
    } catch (error) {
      console.error('❌ Error en PDF con estilos:', error);
      Swal.fire('Error', `Error: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  // ✅ PRUEBA 3: PDF con TODOS los estilos Y con fontWeight: 'medium' (para ver si es ese el problema)
  const probarPDFConMedium = async () => {
    setLoading(true);
    try {
      console.log('🔬 Probando PDF con fontWeight: medium...');
      
      const blob = await pdf(
        <Document>
          <Page size="A4" style={{ padding: 40 }}>
            <Text style={{ fontSize: 20, fontWeight: 'bold' }}>PDF con Medium</Text>
            <Text style={{ fontSize: 14, fontWeight: 'medium', marginTop: 20 }}>Este texto usa fontWeight: 'medium'</Text>
            <Text style={{ fontSize: 14, fontWeight: 'normal', marginTop: 10 }}>Este texto usa fontWeight: 'normal'</Text>
            <Text style={{ fontSize: 14, fontWeight: 500, marginTop: 10 }}>Este texto usa fontWeight: 500</Text>
            <Text style={{ fontSize: 12, marginTop: 30, color: '#666' }}>Fecha: {new Date().toLocaleString()}</Text>
          </Page>
        </Document>
      ).toBlob();
      
      console.log('✅ PDF con medium generado!', blob);
      
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'prueba-medium.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      Swal.fire('Éxito', 'El PDF con medium se descargó correctamente', 'success');
    } catch (error) {
      console.error('❌ Error en PDF con medium:', error);
      Swal.fire('Error', `Error: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="container mx-auto px-4 py-16 max-w-md">
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">🧪 Panel de Prueba PDF</h1>
          <p className="text-gray-500 text-sm text-center mb-6">
            Probá cada botón para identificar qué parte del PDF está fallando.
          </p>
          
          <div className="space-y-4">
            <button
              onClick={probarPDFMinimo}
              disabled={loading}
              className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-medium transition-all disabled:opacity-50"
            >
              {loading ? 'Generando...' : '📄 PDF Mínimo (solo texto)'}
            </button>
            
            <button
              onClick={probarPDFConEstilos}
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-medium transition-all disabled:opacity-50"
            >
              {loading ? 'Generando...' : '🎨 PDF con Estilos Completos'}
            </button>
            
            <button
              onClick={probarPDFConMedium}
              disabled={loading}
              className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-xl font-medium transition-all disabled:opacity-50"
            >
              {loading ? 'Generando...' : '🔬 PDF con fontWeight: medium'}
            </button>
          </div>
          
          <div className="mt-6 p-4 bg-yellow-50 rounded-xl border border-yellow-200">
            <p className="text-sm text-yellow-800">
              <strong>💡 Consejo:</strong> 
              <br />• Si el PDF mínimo funciona pero el de estilos falla → el problema está en algún estilo.
              <br />• Si el PDF con medium falla → el problema es el fontWeight: 'medium'.
              <br />• Si ninguno funciona → el problema es la instalación de @react-pdf/renderer.
            </p>
          </div>

          <button
            onClick={() => navigate('/')}
            className="mt-6 w-full text-gray-500 hover:text-gray-700 text-sm underline"
          >
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompraPrueba;